import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

registerBlockType("template-scripts/thumb-list", {
  title: "Thumbnail List",
  category: "template-scripts",
  icon: "button",
  attributes: {
    items:{type:'array',default:[]},
    backgroundColor:{type:'string',default:'#2b87c3'},
    maxWidth:{type:'number',default:1250},
    columns:{type:'number',default:1},
    border:{type:'boolean',default:false},
    ctaText:{type:'string',default:'Learn More'},
    ctaLink:{type:'object',default:{url:'',title:'',target:''}},
    ctaColor:{type:'string',default:'#2b87c3'},
    // Add any attributes you need here
  },
  edit: function({attributes, setAttributes}) {

    const updateItem = (index,key,value)=>{
        const newItems = [...attributes.items];
        newItems[index][key] = value;
        setAttributes({items:newItems});
    };

    const deleteItem = (index)=>{
        const newItems = [...attributes.items];
        newItems.splice(index,1);
        setAttributes({items:newItems});
    };

    const addItem = ()=>{
        const newItems = [...attributes.items,{text:"",image:null}];
        setAttributes({items:newItems});
    };

    const gridColumnStyle = new Array(attributes.columns).fill("1fr").join(" ");



    const itemComponents = attributes.items.map((item,index)=>{
        return (<li key={index}>
            <MediaUpload
                value={item.image}
                onSelect={(v)=>updateItem(index,"image",v)}
                render={({open})=>(<div className="image">
                    {item.image?.url ? (<img src={item.image.url} onClick={open}/>) : (<button onClick={open}>Select Image</button>)}
                    </div>
                )}
            />
            
            <div className="text">
                <RichText tagName="span" value={item.text} onChange={(v)=>updateItem(index,"text",v)} placeholder="Text Goes Here"/>
                <button onClick={()=>deleteItem(index)}>Delete</button>
            </div>
        </li>);
    });
    return (<>
    <InspectorControls>
      <Panel>
        <PanelBody title="Background">
          <CheckboxControl
            label="Show Border"
            checked={attributes.border}
            onChange={(v)=>setAttributes({border:v})}
          />
          <PMGColorPalette
            value={attributes.backgroundColor}
            onChange={(v)=>setAttributes({backgroundColor:v})}
          />
          <RangeControl
            label="Max Width"
            value={attributes.maxWidth}
            onChange={(v)=>setAttributes({maxWidth:v})}
            min={100}
            max={1600}
            step={1}
          />

        <RangeControl
            label="Column Count"
            value={attributes.columns}
            onChange={(v)=>setAttributes({columns:v})}
            min={1}
            max={4}
            step={1}
          />
          
        
        </PanelBody>
        <PanelBody title="CTA">
            <TextControl
                label="CTA Text"
                value={attributes.ctaText}
                onChange={(v)=>setAttributes({ctaText:v})}
            />
            <LinkControl
                label="CTA Link"
                value={attributes.ctaLink}
                onChange={(v)=>setAttributes({ctaLink:v})}
            />
            <PMGColorPalette
                label="CTA Color"
                value={attributes.ctaColor}
                onChange={(v)=>setAttributes({ctaColor:v})}
            />
        </PanelBody>
      </Panel> 
    </InspectorControls>
      <div {...useBlockProps()} className={`thumb-list ${attributes.border ? "border" : ""}`} style={{backgroundColor:attributes.backgroundColor}}>
        <BlockControls>
          
        </BlockControls>
        <div className="container" style={{width:attributes.maxWidth+"px",maxWidth:"100%"}}>
            <ul style={{gridTemplateColumns:gridColumnStyle}}>
                {itemComponents}
                {attributes.ctaText ? (<div className="cta" target={attributes.ctaLink.target} style={{backgroundColor:attributes.ctaColor}}>{attributes.ctaText}</div>) : (<></>)}
            </ul>
            
        </div>
        <button onClick={addItem} style={{width:"100%",textAlign:"center"}}>Add Item</button>
      </div>
    </>);
  },
  save: function({attributes}) {
    const gridColumnStyle = new Array(attributes.columns).fill("1fr").join(" ");
    const itemComponents = attributes.items.map((item,index)=>{
        return (<li key={index}>
            <div className="image">{item.image?.url ? (<img src={item.image.url}/>) : (<></>)}</div>
            <div className="text"><RichText.Content tagName="span" value={item.text}/></div>
        </li>);
    });
    return (<>
        <div className={`thumb-list ${attributes.border ? "border" : ""}`} style={{backgroundColor:attributes.backgroundColor}}>
            <div className="container" style={{width:attributes.maxWidth+"px",maxWidth:"100%"}}>
                <ul style={{gridTemplateColumns:gridColumnStyle}}>
                    {itemComponents}
                    {attributes.ctaText ? (<a href={attributes.ctaLink.url} target={attributes.ctaLink.target} style={{backgroundColor:attributes.ctaColor}} className="cta">{attributes.ctaText}</a>) : (<></>)}

                </ul>
            </div>
        </div>
    </>);
  }
});
